import React from 'react';
import { ForceGraphData } from '../config/forceGraphTypes';

interface ForceGraphLegendProps {
    data: ForceGraphData;
}

export const ForceGraphLegend: React.FC<ForceGraphLegendProps> = ({ data }) => {
    // Extract unique groups
    const groups = Array.from(new Set(data.nodes.map(n => n.group).filter(Boolean)));

    if (groups.length === 0) return null;

    return (
        <div className="absolute bottom-4 right-4 bg-black/80 backdrop-blur-sm border border-white/10 p-3 rounded-lg shadow-lg max-h-48 overflow-y-auto custom-scrollbar">
            <h5 className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-2">Groups</h5>
            <div className="space-y-1">
                {groups.map((group, i) => (
                    <div key={i} className="flex items-center gap-2">
                        <div className="w-2.5 h-2.5 rounded-full bg-indigo-500" /> {/* Placeholder color */}
                        <span className="text-xs text-gray-300">{group}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};
